import { useDirectoryMode } from '../../hooks/useDirectoryMode'

/** Gas Safe: larger on directory pages. WaterSafe: unchanged visual weight. */
const GAS_SAFE_LOGO_CLASS =
  'h-12 sm:h-14 w-auto object-contain max-w-[min(100%,320px)]'
const WATER_SAFE_LOGO_CLASS =
  'h-8 w-auto object-contain max-h-10 max-w-[220px]'

/**
 * Optional `className` overrides both modes (e.g. for one-off layouts).
 * Omit it to use mode-specific defaults.
 */
export function DirectoryModeLogo({ className }: { className?: string }) {
  const { isGasSafe, isWaterSafe } = useDirectoryMode()

  if (!isGasSafe && !isWaterSafe) return null

  if (isGasSafe) {
    return (
      <img
        src="/logos/gasSafe.svg"
        alt="Gas Safe Register"
        width={120}
        height={135}
        decoding="async"
        className={className ?? GAS_SAFE_LOGO_CLASS}
      />
    )
  }

  return (
    <img
      src="/logos/watersafe.svg"
      alt="WaterSafe"
      width={1920}
      height={377}
      decoding="async"
      className={className ?? WATER_SAFE_LOGO_CLASS}
    />
  )
}
